__webpack_require__.p = "https://assets.canny.io/7b9970a50ff8fb64a0446f37fd7ce07f917f935c/";